import { PageTitle } from "../../../_metronic/layout/core"
import Illustration404 from '../../images/illustrations/404-hd.png'

const Error404 = () => {
    return (
        <>
            <PageTitle>Error 404</PageTitle>
            <div className="d-flex flex-column flex-center flex-column-fluid p-10">
                <img src={Illustration404} alt="" className="mw-100 mb-10 h-lg-450px"/>
                <h1 className="fw-bold mb-10" style={{color: "#A3A3C7"}}>Seems there is nothing here</h1>
                <a href="/" className="btn btn-primary">Return Home</a>
            </div>
        </>
    )
}
export { Error404 }